import React from "react";
import { Helmet } from "react-helmet";

function CookiePolicy() {
    return (
        <>
            <Helmet>
                <title>Cookie Policy | 3PL Search</title>
            </Helmet>

            <div className="legal-page">
                <div className="container" style={{ maxWidth: "800px", padding: "3rem 1.5rem" }}>
                    <h1 style={{ color: "#132238", fontWeight: 800, marginBottom: "0.5rem" }}>Cookie Policy</h1>
                    <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>Last updated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })}</p>

                    <p>This Cookie Policy explains how 3PL Search uses cookies and similar storage technologies when you visit <strong>search.shipcube.com</strong>.</p>

                    <h3>1. What Are Cookies?</h3>
                    <p>Cookies are small text files placed on your device by a website. They are widely used to make websites work efficiently and to provide reporting information.</p>

                    <h3>2. Cookies We Use</h3>

                    <h4 style={{ color: "#132238" }}>Essential Cookies</h4>
                    <p>These cookies are necessary for the platform to function. They cannot be disabled.</p>
                    <div className="table-responsive mb-3">
                        <table className="table table-bordered table-sm">
                            <thead className="table-light">
                                <tr>
                                    <th>Storage Key</th>
                                    <th>Purpose</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><code>token</code></td>
                                    <td>Stores your JWT authentication token to keep you logged in</td>
                                    <td>7 days</td>
                                </tr>
                                <tr>
                                    <td><code>userType</code></td>
                                    <td>Records your account type (User, Client, Marketer) for route access</td>
                                    <td>Session</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="text-muted small">These are stored in <strong>localStorage</strong>, not as browser cookies, but serve an equivalent purpose for session management.</p>

                    <h4 style={{ color: "#132238" }}>Analytics Cookies</h4>
                    <p>We may use anonymised analytics to understand platform usage and improve the service. No personally identifiable information is collected through analytics.</p>

                    <h3>3. Managing Cookies</h3>
                    <p>You can clear stored session data at any time by logging out of your account. You can also clear localStorage through your browser's developer tools or settings.</p>
                    <p>Most browsers allow you to block or delete cookies through their settings. Note that disabling essential storage will prevent you from logging in.</p>

                    <h3>4. Third-Party Services</h3>
                    <p>We do not currently use third-party advertising or tracking cookies. If this changes, this policy will be updated accordingly.</p>

                    <h3>5. Changes to This Policy</h3>
                    <p>We may update this policy as our use of cookies evolves. Changes will be posted on this page with an updated date.</p>

                    <h3>6. Contact</h3>
                    <p>For questions about our use of cookies, contact us at <a href="mailto:privacy@shipcube.com">privacy@shipcube.com</a> or via our <a href="/contact">contact page</a>.</p>
                </div>
            </div>
        </>
    );
}

export default CookiePolicy;
